
// src/services/api.js
// Capa de comunicación React ↔ Express API

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const getToken = () => localStorage.getItem('mb_token') || '';

const headers = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${getToken()}`,
});

const handle = async res => {
  const data = await res.json();
  if (!res.ok) {
    const err = new Error(data.error || `Error HTTP ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return data;
};

const get  = url           => fetch(`${BASE}${url}`, { headers: headers() }).then(handle);
const post = (url, body)   => fetch(`${BASE}${url}`, { method:'POST',  headers: headers(), body: JSON.stringify(body) }).then(handle);
const put  = (url, body)   => fetch(`${BASE}${url}`, { method:'PUT',   headers: headers(), body: JSON.stringify(body) }).then(handle);
const patch = (url, body)  => fetch(`${BASE}${url}`, { method:'PATCH', headers: headers(), body: JSON.stringify(body||{}) }).then(handle);

// ─── Auth ─────────────────────────────────────────────────────
export const auth = {
  login:  ({ email, password }) => post('/auth/login', { email, password }),
  logout: ()                    => post('/auth/logout', {}),
};

// ─── Clientes ─────────────────────────────────────────────────
export const clientes = {
  getAll:       ()           => get('/clientes'),
  create:       body         => post('/clientes', body),
  update:       (id, body)   => put(`/clientes/${id}`, body),
  toggleStatus: id           => patch(`/clientes/${id}/estado`),
};

// ─── Paquetes ─────────────────────────────────────────────────
export const paquetes = {
  getAll:       ()          => get('/paquetes'),
  create:       body        => post('/paquetes', body),
  update:       (id, body)  => put(`/paquetes/${id}`, body),
  createMasivo: body        => post('/paquetes/masivo', body),
  getHistorial: id          => get(`/paquetes/${id}/historial`),
};

// ─── Facturas ─────────────────────────────────────────────────
export const facturas = {
  getAll:  ()                              => get('/facturas'),
  create:  body                            => post('/facturas', body),
  anular:  (id, reason, adminPassword)     => post(`/facturas/${id}/anular`, { reason, adminPassword }),
};

// ─── Entregas ─────────────────────────────────────────────────
export const entregas = {
  getAll:  ()      => get('/entregas'),
  create:  body    => post('/entregas', body),
};

// ─── Configuración ────────────────────────────────────────────
export const settings = {
  get:          ()       => get('/settings'),
  update:       body     => put('/settings', body),
  uploadLogo:   logo     => post('/settings/logo', { logo }),
  deleteLogo:   ()       => fetch(`${BASE}/settings/logo`, { method:'DELETE', headers: headers() }).then(handle),
  updateBancos: bancos   => put('/settings/bancos', { bancos }),
};

// ─── Usuarios ─────────────────────────────────────────────────
export const usuarios = {
  getAll:  ()          => get('/usuarios'),
  create:  body        => post('/usuarios', body),
  update:  (id, body)  => put(`/usuarios/${id}`, body),
};

// ─── Auditoría ────────────────────────────────────────────────
export const auditoria = {
  getAll: (limit=500) => get(`/auditoria?limit=${limit}`),
};

// ─── Reportes ─────────────────────────────────────────────────
export const reportes = {
  dashboard:        ()              => get('/reportes/dashboard'),
  clientes:         ()              => get('/reportes/clientes'),
  ingresosMensuales: year           => get(`/reportes/ingresos-mensuales${year?'?year='+year:''}`),
  kpis:             (desde, hasta)  => get(`/reportes/kpis?desde=${desde}&hasta=${hasta}`),
};

// ─── Órdenes de Pago ──────────────────────────────────────────
export const ordenes = {
  getAll:    ()          => get('/ordenes'),
  getOne:    id          => get(`/ordenes/${id}`),
  create:    body        => post('/ordenes', body),
  update:    (id, body)  => put(`/ordenes/${id}`, body),
  cancelar:  (id, reason) => post(`/ordenes/${id}/cancelar`, { reason }),
  convertir: (id, body)  => post(`/ordenes/${id}/convertir`, body),
};

// ─── Gastos ───────────────────────────────────────────────────
export const gastos = {
  getAll:    (params={}) => {
    const qs = new URLSearchParams(Object.entries(params).filter(([,v])=>v)).toString();
    return get(`/gastos${qs?'?'+qs:''}`);
  },
  resumen:         ()          => get('/gastos/resumen'),
  porCategoria:    ()          => get('/gastos/por-categoria'),
  create:          body        => post('/gastos', body),
  anular:          (id, reason, adminPassword) => post(`/gastos/${id}/anular`, { reason, adminPassword }),
};

// ─── Períodos ─────────────────────────────────────────────────
export const periodos = {
  getAll:   ()     => get('/periodos'),
  getActivo: ()    => get('/periodos/activo'),
  create:   body   => post('/periodos', body),
  cerrar:   id     => post(`/periodos/${id}/cerrar`, {}),
  abrir:    id     => post(`/periodos/${id}/abrir`, {}),
  delete:   id     => fetch(`${BASE}/periodos/${id}`, { method: 'DELETE', headers: headers() }).then(handle),
};

// ─── Roles y Permisos ───────────────────────────────────────────
export const roles = {
  getAll:           ()                  => get('/roles'),
  getPermisosCatalog: ()                => get('/roles/permisos'),
  getPermisosByRol: id                  => get(`/roles/${id}/permisos`),
  create:           body                => post('/roles', body),
  update:           (id, body)          => put(`/roles/${id}`, body),
  updatePermisos:   (id, permisoIds)    => put(`/roles/${id}/permisos`, { permisoIds }),
  duplicar:         (id, nombre)        => post(`/roles/${id}/duplicar`, { nombre }),
  delete:           id                  => fetch(`${BASE}/roles/${id}`, { method: 'DELETE', headers: headers() }).then(handle),
};

// ─── Preferencias de Dashboard (por usuario) ─────────────────────
export const dashboardPrefs = {
  get:    ()        => get('/dashboard-prefs'),
  update: tarjetas  => put('/dashboard-prefs', { tarjetas }),
};
